import clsx from 'clsx'

interface SeparatorProps {
  text?: string
  direction?: 'horizontal' | 'vertical'
  className?: string
  textClassName?: string
}

export const Separator = ({
  text,
  direction = 'horizontal',
  className = '',
  textClassName = '',
}: SeparatorProps) => {
  return (
    <div
      className={clsx(
        'flex items-center',
        {
          'flex-col h-full': direction === 'vertical',
          'w-full': direction === 'horizontal',
        },
        className,
      )}
    >
      <div
        className={clsx('flex-1 bg-gray-300', {
          'w-px': direction === 'vertical',
          'h-px': direction === 'horizontal',
        })}
      ></div>
      {text && (
        <div
          className={clsx(
            'text-sm text-white/60',
            {
              'px-2 py-3': direction === 'vertical',
              'px-4': direction === 'horizontal',
            },
            textClassName,
          )}
        >
          {text}
        </div>
      )}
      <div
        className={clsx('flex-1 bg-gray-300', {
          'w-px': direction === 'vertical',
          'h-px': direction === 'horizontal',
        })}
      ></div>
    </div>
  )
}
